export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idauthority: '',
        nombre: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}